import React from "react";
import { Truck } from "lucide-react";
import { kitQualifiesFreeShipping } from "../lib/pricing";

const STYLES = {
  rose: { background: "hsl(var(--brand-rose))", color: "#fff" },
  brown: { background: "hsl(var(--brand-brown))", color: "#fff" },
  gold: { background: "hsl(var(--warning))", color: "#fff" },
  green: { background: "hsl(var(--success))", color: "#fff" },
};

// Compute the badges for a kit: manual promotional badges (set in Admin) plus an
// automatic FREE SHIPPING badge driven by the ACTIVE free-shipping rule
// (by order value OR by magnet quantity).
export function kitBadges(kit, settings, t) {
  const out = [];
  const manual = Array.isArray(kit?.badges) ? kit.badges : [];
  const map = {
    "MOST POPULAR": { label: t("most_popular"), cls: "rose" },
    "BEST SELLER": { label: t("best_seller"), cls: "gold" },
    "BEST VALUE": { label: t("best_value"), cls: "brown" },
  };
  manual.forEach((b) => { if (map[b]) out.push({ key: b, ...map[b] }); });
  if (kitQualifiesFreeShipping(settings, kit)) {
    out.push({ key: "FREE SHIPPING", label: t("free_shipping"), cls: "green", icon: true });
  }
  return out;
}

export const KitBadges = ({ badges, className = "" }) => {
  if (!badges || badges.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid="kit-badges">
      {badges.map((b) => (
        <span
          key={b.key}
          data-testid={`badge-${b.key.toLowerCase().replace(/\s+/g, "-")}`}
          className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide leading-none"
          style={STYLES[b.cls] || STYLES.rose}
        >
          {b.icon ? <Truck className="h-2.5 w-2.5" /> : null}
          {b.label}
        </span>
      ))}
    </div>
  );
};
